import PriceSourceModalComponent from "./PriceSourceModalComponent";

export default PriceSourceModalComponent;
